'use strict';

/** @flow */

import React, {PropTypes} from 'react';
import './styles.scss';

class FormTextarea extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    // console.log("[FormTextarea] handleChange", this.props);
    this.props.onChange(this.props.name, event.target.value);
  }

  render(): ?ReactElement {
    var errorsDisplay = '',
        errors = this.props.errors,
        formGroupClass = 'form-group ';

    if (errors && errors[this.props.name] && errors[this.props.name].length > 0) {
      errorsDisplay = (
        <small className="help-block">{errors[this.props.name].join(', ')}</small>
      );

      formGroupClass += 'has-error';
    } else if (errors && errors["first_name"]) {
      errorsDisplay = (
        <small className="help-block">First name {errors["first_name"].join(', ')}</small>
      );

      formGroupClass += 'has-error';
    } else if (errors && errors["last_name"]) {
      errorsDisplay = (
        <small className="help-block">Last name {errors["last_name"].join(', ')}</small>
      );

      formGroupClass += 'has-error';
    }

    return (
      <div className={this.props.className}>
        <div className={formGroupClass}>
          <label className="control-label hidden-xs hidden-sm">{this.props.label}</label>

          <textarea
            rows={this.props.rows}
            value={this.props.value}
            onChange={this.handleChange}
            name={this.props.name}
            className="form-control"
            placeholder={this.props.placeholder}
            autoFocus={this.props.autoFocus} />

          {errorsDisplay}
        </div>
      </div>
    );
  }
}

FormTextarea.propTypes = {
  rows: PropTypes.any.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
  // keep going
};

export default FormTextarea;



/** WEBPACK FOOTER **
 ** ../components/FormTextarea/index.js
 **/